/*
 * Validating-category.ts
 * Description: Includes the declaration
 * of the function for validating a category
 */

// Importing variables
import {
    MissingFirstName,
    TooLongFirstName,
} from '@/ts/variables';

export interface Category {
    name: string;
    description: string;
    order: number;
    is_active: number;
}

/**
 * Validating category data
 *
 * @param {String[]} errors - a list of errors
 * @param {Category} data - category data
 */
export function validateCategory(errors: string[], data: Category) {
    // Validating name
    if (data.name.length === 0) { errors.push(MissingFirstName); }
    if (data.name.length > 255) { errors.push(TooLongFirstName); }
}
